/* yn-core.js - window.Yuno: config, events, remembered size, cart, sheets, toasts, the declarative data-yn-* attributes,
   the <html> state classes and the add-to-cart button states. Plain JS, no library.
   Loaded once by the yn-head snippet (deferred, after yn-kit.js). It uses window.YK for motion when it is there and works without it.
   window.Yuno.config is written inline by yn-head before this runs; it is merged with defaults, never replaced. */
(function () {
  'use strict';
  var win = window, doc = document, html = doc.documentElement;
  if (win.__ynCore) return;
  win.__ynCore = true;

  var Yuno = (win.Yuno = win.Yuno || {});
  /* T: the visitor's-language text for a string written in English (Yuno.T comes from yn-head; this falls back to the English). */
  function T(s, p) {
    var f = win.Yuno && win.Yuno.T;
    if (f) return f(s, p);
    s = String(s == null ? '' : s);
    if (p) for (var k in p) s = s.split('[' + k + ']').join(p[k]);
    return s;
  }
  var SIZES = ['18-24 months', '2-3 years', '3-4 years', '4-5 years', '5-6 years', '6-7 years'];
  var DEFAULTS = {
    market: 'EG', currency: 'EGP', threshold: 150000, shippingRate: 7000, gulfRate: 125000, deliveryDays: T('2–3 working days'),
    whatsapp: '201044141173', lowStock: 5, upgrades: true, moneyFormat: 'LE {{amount}} EGP', locale: 'en', designMode: false,
    routes: { root: '/', cart: '/cart', cartJs: '/cart.js', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', search: '/search', predictive: '/search/suggest' },
    sizes: SIZES
  };
  var cfg = (Yuno.config = Yuno.config || {});
  Object.keys(DEFAULTS).forEach(function (k) { if (cfg[k] === undefined || cfg[k] === null) cfg[k] = DEFAULTS[k]; });
  cfg.routes = cfg.routes || {};
  Object.keys(DEFAULTS.routes).forEach(function (k) { if (!cfg.routes[k]) cfg.routes[k] = DEFAULTS.routes[k]; });
  var isEg = function () { return cfg.market === 'EG'; };

  var reduced = win.matchMedia ? win.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var desktopMq = win.matchMedia ? win.matchMedia('(min-width: 990px)') : { matches: false };
  var hoverMq = win.matchMedia ? win.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  if (win.YK && win.YK.setUpgrades) win.YK.setUpgrades(cfg.upgrades !== false);
  // kind: 'answer' (always unless reduced), 'charm' (level 2), 'up' (level 2 + upgrades)
  function ok(kind) {
    if (win.YK && win.YK.ok) return win.YK.ok(kind);
    if (reduced.matches) return false;
    return kind === 'up' ? cfg.upgrades !== false : true;
  }

  /* ------------------------------------------------------------ small helpers */
  function qa(sel, root) {
    var r = root || doc, out = [];
    if (r.nodeType === 1 && r.matches && r.matches(sel)) out.push(r);
    if (r.querySelectorAll) { var l = r.querySelectorAll(sel); for (var i = 0; i < l.length; i++) out.push(l[i]); }
    return out;
  }
  function delay(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  function storageGet(k) { try { return win.localStorage.getItem(k); } catch (e) { return mem[k] == null ? null : mem[k]; } }
  function storageSet(k, v) { try { if (v == null) win.localStorage.removeItem(k); else win.localStorage.setItem(k, v); } catch (e) { mem[k] = v; } }
  var mem = {};
  function readableError(message, status) {
    var e = new Error(message);
    e.status = status;
    e.toString = function () { return message; };   // String(err) is the readable message too
    return e;
  }

  /* ------------------------------------------------------------ the <html> state classes */
  function motionClasses() {
    html.classList.toggle('yn-reduced', !!reduced.matches);
    html.classList.toggle('yn-upgrades', cfg.upgrades !== false);
  }
  motionClasses();
  if (reduced.addEventListener) reduced.addEventListener('change', motionClasses); else if (reduced.addListener) reduced.addListener(motionClasses);
  // photos that already arrived must not blink out when the fade-in rule starts to apply
  qa('img[data-yn-fade]').forEach(function (img) { if (img.complete && img.naturalWidth > 0) img.classList.add('is-in'); });
  html.classList.add('yn-js');
  doc.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.localName === 'img' && t.hasAttribute('data-yn-fade')) t.classList.add('is-in');
  }, true);

  (function scrollDirection() {
    var lastY = win.pageYOffset, ticking = false, stopT = 0;
    win.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = win.pageYOffset, dy = y - lastY;
        lastY = y;
        if (y <= 0 || dy < -2) html.classList.remove('yn-scrolling-down');
        else if (dy > 2) html.classList.add('yn-scrolling-down');
        clearTimeout(stopT);
        stopT = setTimeout(function () { html.classList.remove('yn-scrolling-down'); }, 300);
      });
    }, { passive: true });
  })();

  /* ------------------------------------------------------------ events */
  function emit(name, detail) {
    var e;
    try { e = new CustomEvent(name, { detail: detail, bubbles: true }); }
    catch (x) { e = doc.createEvent('CustomEvent'); e.initCustomEvent(name, true, false, detail); }
    if (detail && typeof detail === 'object') {   // the detail keys are reachable on the event too: e.cart as well as e.detail.cart
      Object.keys(detail).forEach(function (k) { if (!(k in e)) { try { e[k] = detail[k]; } catch (x) {} } });
    }
    doc.dispatchEvent(e);
    return e;
  }
  function on(name, fn) {
    var h = function (e) { fn.call(doc, e, e.detail); };
    doc.addEventListener(name, h);
    return function () { doc.removeEventListener(name, h); };
  }
  Yuno.emit = emit;
  Yuno.on = on;

  /* ------------------------------------------------------------ money, sizes, WhatsApp */
  function groupedAmount(cents) {
    var n = (Number(cents) || 0) / 100;
    try { return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return n.toFixed(2); }
  }
  // EGP: "LE 400.00 EGP". Any other presentment currency: that currency's own format (Intl), then the store's format.
  Yuno.money = function (cents) {
    if (cfg.currency === 'EGP' || !cfg.currency) return 'LE ' + groupedAmount(cents) + ' EGP';
    try { return new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: cfg.currency }).format((Number(cents) || 0) / 100); }
    catch (e) {
      var amount = groupedAmount(cents);
      return String(cfg.moneyFormat || '{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }
  };
  // Same rule as the yn-size snippet. '' if the value is not one of the six sizes.
  Yuno.normSize = function (value) {
    var v = String(value == null ? '' : value).toLowerCase().trim()
      .replace(/[‐-―−]/g, '-').replace(/\s+/g, ' ').replace(/\s*-\s*/g, '-');
    if (v === '18-24 months' || v === '12-24 months' || v === '1.5-2 years' || v === '18-24 month') return '18-24 months';
    return SIZES.indexOf(v) > -1 ? v : '';
  };
  Yuno.wa = function (text) { return 'https://wa.me/' + cfg.whatsapp + (text ? '?text=' + encodeURIComponent(text) : ''); };

  var AGE_KEY = 'yuno-age';
  Yuno.size = {
    get: function () { return Yuno.normSize(storageGet(AGE_KEY)) || null; },
    set: function (label) {
      var s = label ? Yuno.normSize(label) : '';
      storageSet(AGE_KEY, s || null);
      paintSize();
      emit('yuno:size', { size: s || null });
      return s || null;
    }
  };
  function paintSize(root) {
    var s = Yuno.size.get();
    qa('[data-yn-size-label]', root).forEach(function (el) { el.textContent = s ? T(s) : (el.getAttribute('data-empty') || ''); });
    qa('[data-yn-card]', root).forEach(function (card) { cardAge(card, s); });
  }
  win.addEventListener('storage', function (e) { if (e.key === AGE_KEY) { paintSize(); emit('yuno:size', { size: Yuno.size.get() }); } });

  // the card's line for the remembered size: "3 left in 3-4 years", "in stock in ...", "sold out in ...", "not made in ..."
  function cardAge(card, size) {
    var line = card.querySelector('[data-yn-age]'), row = card.querySelector('.yn-card__sizes');
    if (!line) return;
    if (!size || card.getAttribute('data-available') !== 'true') { line.hidden = true; if (row) row.hidden = false; return; }
    var map = {};
    (card.getAttribute('data-stock') || '').split(',').forEach(function (p) { var i = p.lastIndexOf(':'); if (i > 0) map[p.slice(0, i)] = parseInt(p.slice(i + 1), 10); });
    var n = map[size], text, good = true, icon = 'tick';
    if (n === undefined) { text = T('Not made in [n]', { n: T(size) }); good = false; icon = 'close'; }
    else if (n === 0) { text = T('Sold out in [n]', { n: T(size) }); good = false; icon = 'close'; }
    else if (n > 0) text = T('[n] left in [a]', { n: n, a: T(size) });
    else text = T('In stock in [n]', { n: T(size) });
    line.className = 'yn-card__age' + (good ? '' : ' is-no');
    line.innerHTML = (win.YK && win.YK.icon ? win.YK.icon(icon, 14) : '') + '<span></span>';
    line.lastChild.textContent = text;
    line.hidden = false;
    if (row) row.hidden = true;
  }

  /* ------------------------------------------------------------ live region */
  var liveEl = null;
  Yuno.announce = function (message) {
    if (!liveEl) {
      liveEl = doc.createElement('div');
      liveEl.className = 'yn-vh';
      liveEl.id = 'yn-live';
      liveEl.setAttribute('role', 'status');
      liveEl.setAttribute('aria-live', 'polite');
      liveEl.setAttribute('aria-atomic', 'true');
      doc.body.appendChild(liveEl);
    }
    liveEl.textContent = '';
    setTimeout(function () { liveEl.textContent = message; }, 30);
  };

  /* ------------------------------------------------------------ cart */
  var holdCount = false, heldCount = null;
  function countOf(cart) { return cart && typeof cart.item_count === 'number' ? cart.item_count : 0; }
  function paintCounts(n, pop) {
    qa('[data-yn-cart-count]').forEach(function (el) {
      var prev = parseInt(el.textContent, 10) || 0;
      el.textContent = String(n);
      el.hidden = n < 1;
      if (pop && n > prev && win.YK) win.YK.pop(el, 1.45);
    });
  }
  function http(url, opts, fallbackMessage) {
    opts = opts || {};
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    opts.credentials = 'same-origin';
    return fetch(url, opts).then(function (r) {
      return r.text().then(function (t) {
        var json = null;
        try { json = t ? JSON.parse(t) : null; } catch (e) {}
        if (!r.ok) {
          var msg = json && (json.description || (typeof json.errors === 'string' ? json.errors : '') || (json.message && json.message !== 'Cart Error' ? json.message : ''));
          throw readableError(msg || fallbackMessage, r.status);
        }
        return json;
      });
    }, function () { throw readableError(fallbackMessage, 0); });
  }
  function setCart(cart, extra) {
    Yuno.cart.state = cart;
    var n = countOf(cart);
    if (holdCount) heldCount = n; else paintCounts(n, true);
    emit('yuno:cart', Object.assign({ cart: cart }, extra || {}));
    return cart;
  }
  Yuno.cart = {
    state: null,
    refresh: function () {
      return http(cfg.routes.cartJs, { cache: 'no-store' }, T('Couldn’t reach your cart. Check your connection and try again.')).then(function (cart) { return setCart(cart); });
    },
    add: function (items, opts) {
      opts = opts || {};
      items = Array.isArray(items) ? items : [items];
      var payload = items.filter(Boolean).map(function (it) {
        var o = { id: Number(it.id), quantity: it.quantity > 0 ? Math.floor(it.quantity) : 1 };
        if (it.properties) o.properties = it.properties;
        if (it.selling_plan) o.selling_plan = it.selling_plan;
        return o;
      });
      if (!payload.length) return Promise.reject(readableError(T('Pick a size first.'), 0));
      return http(cfg.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: payload }) },
        T('Couldn’t add that. Check your connection and try again.')).then(function (res) {
        var added = (res && res.items) || (res ? [res] : []);
        return Yuno.cart.refresh().catch(function () { return Yuno.cart.state; }).then(function (cart) {
          emit('yuno:cart:added', { items: added, source: opts.source || 'unknown', cart: cart });
          return cart;
        });
      });
    },
    change: function (lineKey, quantity) {
      var body = typeof lineKey === 'number' && lineKey <= 1000 ? { line: lineKey, quantity: quantity } : { id: String(lineKey), quantity: quantity };
      return http(cfg.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) },
        T('Couldn’t update your cart. Try again.')).then(function (cart) { return setCart(cart); });
    },
    note: function (text) {
      return http(cfg.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: String(text == null ? '' : text) }) },
        T('Couldn’t save your note. Try again.')).then(function (cart) { return setCart(cart, { source: 'note' }); });
    },
    open: function (opts) { return Yuno.sheet.open('yn-sheet-cart', opts) || (win.location.href = cfg.routes.cart); },
    close: function () { return Yuno.sheet.close('yn-sheet-cart'); }
  };
  var defaultCartOpen = Yuno.cart.open;

  /* ------------------------------------------------------------ the sheet manager */
  var stack = [];            // open sheets, bottom first: { id, el, opener }
  var histIds = [];          // ids of the history entries we pushed (null = orphan), oldest first
  var pendingBack = 0, deferred = [], fallbackT = 0;

  function sheetEl(id) { var el = typeof id === 'string' ? doc.getElementById(id) : id; return el && el.nodeType === 1 ? el : null; }
  function stackIndex(el) { for (var i = 0; i < stack.length; i++) if (stack[i].el === el) return i; return -1; }
  function isRtl() { return win.getComputedStyle(html).direction === 'rtl'; }
  function focusables(root) {
    return qa('a[href],button,input:not([type="hidden"]),select,textarea,summary,[tabindex]', root).filter(function (el) {
      return !el.disabled && el.tabIndex >= 0 && !el.hidden && !el.closest('[hidden],[inert]') && el.getClientRects().length > 0;
    });
  }
  function lock(on) {
    if (on) {
      html.style.setProperty('--yn-sbw', Math.max(0, win.innerWidth - html.clientWidth) + 'px');
      html.classList.add('yn-sheet-open');
    } else {
      html.classList.remove('yn-sheet-open');
      html.style.removeProperty('--yn-sbw');
    }
  }
  function armFallback() {
    clearTimeout(fallbackT);
    fallbackT = setTimeout(function () { pendingBack = 0; flush(); }, 600);   // if popstate never arrives, carry on
  }
  function flush() {
    var q = deferred.splice(0);
    q.forEach(function (f) { f(); });
  }
  function openSheet(id, opts) {
    opts = opts || {};
    var el = sheetEl(id);
    if (!el) return false;
    if (pendingBack > 0) { deferred.push(function () { openSheet(el, opts); }); armFallback(); return true; }
    if (stackIndex(el) > -1) return true;
    clearTimeout(el.__ynT);
    stack.push({ id: el.id, el: el, opener: opts.opener || doc.activeElement });
    el.hidden = false;
    el.removeAttribute('hidden');
    el.style.zIndex = String(1000 + stack.length * 2);
    if (stack.length === 1) lock(true);
    var panel = el.querySelector('.yn-sheet__panel');
    if (panel) { panel.style.transition = ''; panel.style.transform = ''; if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1'); }
    void el.offsetWidth;   // start from the closed position
    el.classList.add('is-open');
    try { win.history.pushState({ ynSheet: el.id }, '', win.location.href); histIds.push(el.id); } catch (e) {}
    // the pieces rise one after another (40ms apart)
    if (ok('charm')) {
      qa('[data-yn-si]', el).slice(0, 12).forEach(function (n, i) {
        if (!n.animate) return;
        n.animate([{ opacity: 0, translate: '0 14px' }, { opacity: 1, translate: '0 0' }], { duration: 300, delay: 120 + Math.min(i, 6) * 40, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' });
      });
    }
    setTimeout(function () {
      if (stackIndex(el) < 0) return;
      var target = el.querySelector('[data-yn-autofocus],[autofocus]') || el.querySelector('.yn-sheet__x') || panel;
      if (target && target.focus) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
    }, 60);
    emit('yuno:sheet:open', { id: el.id, el: el });
    return true;
  }
  function visualClose(el, item) {
    el.classList.remove('is-open');
    var panel = el.querySelector('.yn-sheet__panel');
    if (panel) { panel.style.transition = ''; panel.style.transform = ''; }
    el.__ynT = setTimeout(function () {
      if (!el.classList.contains('is-open')) { el.hidden = true; el.style.zIndex = ''; }
    }, reduced.matches ? 160 : 280);
    if (!stack.length) lock(false);
    var next = stack.length ? stack[stack.length - 1].el : null;
    var back = item && item.opener;
    if (next) { var f = focusables(next)[0]; if (f) f.focus({ preventScroll: true }); }
    else if (back && back.isConnected && back.focus) { try { back.focus({ preventScroll: true }); } catch (e) {} }
    emit('yuno:sheet:close', { id: el.id, el: el });
  }
  function closeSheet(id, opts) {
    opts = opts || {};
    var el = id ? sheetEl(id) : (stack.length ? stack[stack.length - 1].el : null);
    if (!el) return false;
    var i = stackIndex(el);
    if (i < 0) return false;
    var item = stack.splice(i, 1)[0];
    visualClose(el, item);
    if (!opts.fromPop) {
      var hi = histIds.lastIndexOf(el.id);
      if (hi > -1 && hi === histIds.length - 1) {
        histIds.pop();
        pendingBack++;
        try { win.history.back(); armFallback(); } catch (e) { pendingBack--; }
      } else if (hi > -1) histIds[hi] = null;   // not on top: its history entry stays behind, harmless
    }
    return true;
  }
  win.addEventListener('popstate', function () {
    if (pendingBack > 0) {
      pendingBack--;
      if (!pendingBack) { clearTimeout(fallbackT); flush(); }
      return;
    }
    if (!histIds.length) return;                       // an ordinary navigation, not ours
    var id = histIds.pop();
    if (id) closeSheet(id, { fromPop: true });
  });
  win.addEventListener('pageshow', function (e) {      // back/forward cache: start clean
    if (!e.persisted) return;
    stack.slice().forEach(function (s) { s.el.classList.remove('is-open'); s.el.hidden = true; s.el.style.zIndex = ''; });
    stack = []; histIds = []; pendingBack = 0; deferred = [];
    lock(false);
    if (Yuno.cart.state) Yuno.cart.refresh().catch(function () {});
  });
  doc.addEventListener('keydown', function (e) {
    if (!stack.length) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var top = stack[stack.length - 1].el, list = focusables(top), a = doc.activeElement;
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0], last = list[list.length - 1];
    if (!top.contains(a)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });
  Yuno.sheet = {
    open: openSheet,
    close: function (id, opts) { return closeSheet(id, opts); },
    top: function () { return stack.length ? stack[stack.length - 1].id : null; }
  };

  // drag the head down (or toward the inline start for the menu) to dismiss
  var drag = null;
  doc.addEventListener('pointerdown', function (e) {
    var head = e.target.closest && e.target.closest('[data-yn-sheet-drag]');
    if (!head || (e.button !== undefined && e.button > 0)) return;
    if (e.target.closest('button,a,input,select,textarea,[data-yn-sheet-close]')) return;
    var sheet = head.closest('.yn-sheet');
    if (!sheet || stackIndex(sheet) < 0) return;
    var start = sheet.classList.contains('yn-sheet--start'), full = sheet.classList.contains('yn-sheet--full');
    if ((desktopMq.matches && !start) || full) return;               // a modal, a drawer or the search screen: no dragging
    var panel = sheet.querySelector('.yn-sheet__panel');
    if (!panel) return;
    drag = { sheet: sheet, panel: panel, mode: start ? 'x' : 'y', x: e.clientX, y: e.clientY, d: 0, t: Date.now(), id: e.pointerId, head: head };
    panel.style.transition = 'none';
    try { head.setPointerCapture(e.pointerId); } catch (x) {}
  }, { passive: true });
  doc.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var d;
    if (drag.mode === 'y') d = Math.max(0, e.clientY - drag.y);
    else d = isRtl() ? Math.max(0, e.clientX - drag.x) : Math.min(0, e.clientX - drag.x);
    drag.d = d;
    drag.panel.style.transform = drag.mode === 'y' ? 'translateY(' + d + 'px)' : 'translateX(' + d + 'px)';
  }, { passive: true });
  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var g = drag; drag = null;
    g.panel.style.transition = '';
    var dist = Math.abs(g.d), v = dist / Math.max(1, Date.now() - g.t);
    if (dist > 90 || (v > 0.6 && dist > 20)) closeSheet(g.sheet);
    else g.panel.style.transform = '';
  }
  doc.addEventListener('pointerup', endDrag, { passive: true });
  doc.addEventListener('pointercancel', endDrag, { passive: true });

  /* ------------------------------------------------------------ toasts */
  var toastEl = null, toastT = 0, toastMs = 0, toastHover = false;
  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = doc.createElement('div');
    toastEl.className = 'yn-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.setAttribute('aria-atomic', 'true');
    toastEl.addEventListener('pointerenter', function () { toastHover = true; clearTimeout(toastT); });
    toastEl.addEventListener('pointerleave', function () { toastHover = false; if (toastEl.classList.contains('is-on')) toastT = setTimeout(hideToast, 1800); });
    doc.body.appendChild(toastEl);
    return toastEl;
  }
  function hideToast() {
    if (!toastEl) return;
    clearTimeout(toastT);
    toastEl.classList.remove('is-on');
    html.classList.remove('yn-toast-open');
  }
  // opts: { photo, sub, actionLabel, onAction, ms }
  Yuno.toast = function (message, opts) {
    opts = opts || {};
    var el = ensureToast();
    clearTimeout(toastT);
    el.textContent = '';
    if (opts.photo) {
      var img = doc.createElement('img');
      img.className = 'yn-toast__img'; img.alt = ''; img.width = 36; img.height = 45; img.src = opts.photo;
      el.appendChild(img);
    }
    var text = doc.createElement('div'), title = doc.createElement('div');
    text.className = 'yn-toast__text'; title.className = 'yn-toast__title'; title.textContent = message == null ? '' : String(message);
    text.appendChild(title);
    if (opts.sub) { var sub = doc.createElement('div'); sub.className = 'yn-toast__sub'; sub.textContent = String(opts.sub); text.appendChild(sub); }
    el.appendChild(text);
    if (opts.actionLabel) {
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'yn-toast__act'; b.textContent = opts.actionLabel;
      b.addEventListener('click', function () { var f = opts.onAction; hideToast(); if (f) f(); });
      el.appendChild(b);
    }
    toastMs = opts.ms || (opts.actionLabel ? 4200 : 2600);
    void el.offsetWidth;
    el.classList.add('is-on');
    html.classList.add('yn-toast-open');
    toastT = setTimeout(hideToast, toastMs);
    return { hide: hideToast };
  };
  Yuno.toast.hide = hideToast;

  /* ------------------------------------------------------------ add-to-cart button states */
  var DOTS = '<span class="yn-btn__dots" aria-hidden="true"><i></i><i></i><i></i></span><span class="yn-vh"></span>';   // the hidden label is filled in with its text
  function cartTarget() {
    var list = qa('[data-yn-cart-open]');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.top >= -2 && r.left >= -2 && r.bottom <= win.innerHeight + 2 && r.right <= win.innerWidth + 2 && win.getComputedStyle(list[i]).visibility !== 'hidden') return list[i];
    }
    return null;
  }
  function releaseCount(pop) {
    holdCount = false;
    var n = heldCount != null ? heldCount : countOf(Yuno.cart.state);
    heldCount = null;
    paintCounts(n, pop !== false);
  }
  /* Yuno.addButton(button, promise, opts)
     promise: the pending Yuno.cart.add(...) (or any promise).
     opts: { photo: url (the product photo flies to the cart mark), doneLabel: T('Added!'), errorLabel: T('Try again'), hold: 600,
             errorEl: an element that receives the error message (otherwise a toast does), onSuccess(cart), onError(err) }
     The button presses, shows three bouncing dots while the request runs, then a tick and "Added!" for about 600ms, or shakes and says "Try again".
     Returns a promise that resolves with the promise's value after the success state has held (open the cart then), or rejects with the error. */
  Yuno.addButton = function (btn, promise, opts) {
    opts = opts || {};
    if (!btn) return Promise.resolve(promise);
    if (btn.__ynAdd) return btn.__ynAdd;
    var K = win.YK, original = btn.innerHTML, started = Date.now();
    btn.style.minWidth = btn.offsetWidth ? btn.offsetWidth + 'px' : '';
    if (K && K.press) K.press(btn);
    btn.classList.remove('is-done', 'is-error');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = DOTS;
    btn.lastChild.textContent = T('Adding to cart');
    var flies = !!opts.photo && !!K && !!K.fly && ok('up') && !!cartTarget();
    if (flies) { holdCount = true; heldCount = null; setTimeout(function () { if (holdCount) releaseCount(false); }, 8000); }
    var reset = function () {
      btn.innerHTML = original;
      btn.classList.remove('is-loading', 'is-done', 'is-error');
      btn.removeAttribute('aria-busy');
      btn.style.minWidth = '';
      if (opts.errorEl) opts.errorEl.textContent = '';
      btn.__ynAdd = null;
    };
    var settled = Promise.resolve(promise).then(function (v) { return { ok: true, v: v }; }, function (e) { return { ok: false, e: e }; });
    var chain = Promise.all([settled, delay(200)]).then(function (r) {
      var res = r[0];
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (res.ok) {
        var label = opts.doneLabel || T('Added!');
        btn.classList.add('is-done');
        btn.innerHTML = '<span class="yn-btn__tick">' + (K && K.icon ? K.icon('tick', 20) : '') + '</span><span></span>';
        btn.lastChild.textContent = label;
        Yuno.announce(label);
        if (opts.onSuccess) { try { opts.onSuccess(res.v); } catch (x) {} }
        if (flies) {
          var tgt = cartTarget();
          // the count pops when the photo lands; never wait longer than the arc plus a little
          Promise.race([tgt ? K.fly(btn, tgt, opts.photo) : Promise.resolve(), delay(800)]).then(function () { releaseCount(true); });
        } else releaseCount(false);
        return delay(opts.hold || 600).then(function () { reset(); return res.v; });
      }
      releaseCount(false);
      var err = res.e, msg = err && err.message ? err.message : T('Couldn’t add that. Check your connection and try again.');
      btn.classList.add('is-error');
      btn.innerHTML = '<span></span>';
      btn.firstChild.textContent = opts.errorLabel || T('Try again');
      if (K && K.shake) K.shake(btn, 4);
      if (opts.errorEl) opts.errorEl.textContent = msg; else Yuno.toast(msg);
      Yuno.announce(msg);
      if (opts.onError) { try { opts.onError(err); } catch (x) {} }
      return delay(1600).then(function () { reset(); throw err; });
    });
    btn.__ynAdd = chain;
    return chain;
  };

  /* ------------------------------------------------------------ quick add (package D replaces .open) */
  Yuno.quickAdd = {
    open: function (handle) {
      win.location.href = String(cfg.routes.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(handle);
    }
  };

  /* ------------------------------------------------------------ declarative attributes */
  function modified(e) { return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button !== undefined && e.button > 0); }
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el = t.closest('[data-yn-sheet-close]');
    if (el) {
      var sh = el.closest('.yn-sheet');
      if (sh) { e.preventDefault(); closeSheet(sh); return; }
    }
    el = t.closest('[data-yn-sheet-open]');
    if (el) {
      if (modified(e)) return;
      var id = el.getAttribute('data-yn-sheet-open');
      if (sheetEl(id)) { e.preventDefault(); openSheet(id, { opener: el }); }
      return;
    }
    el = t.closest('[data-yn-cart-open]');
    if (el) {
      if (modified(e)) return;
      if (el.localName === 'a' && !sheetEl('yn-sheet-cart') && Yuno.cart.open === defaultCartOpen) return;   // no cart sheet on this page: follow the link
      e.preventDefault();
      Yuno.cart.open({ opener: el });
      return;
    }
    el = t.closest('[data-yn-quick-add]');
    if (el) {
      e.preventDefault();
      e.stopPropagation();
      Yuno.quickAdd.open(el.getAttribute('data-yn-quick-add'), { opener: el, source: 'card' });
    }
  });

  function hydrate(root) {
    qa('[data-yn-wa]', root).forEach(function (a) {
      a.setAttribute('href', Yuno.wa(a.getAttribute('data-yn-wa')));
      if (!a.hasAttribute('target')) a.setAttribute('target', '_blank');
      if (!a.hasAttribute('rel')) a.setAttribute('rel', 'noopener');
    });
    qa(isEg() ? '[data-yn-not-egypt]' : '[data-yn-egypt]', root).forEach(function (el) { el.remove(); });
    qa('[data-yn-cart-count]', root).forEach(function (el) {
      var n = Yuno.cart.state ? countOf(Yuno.cart.state) : parseInt(el.textContent, 10) || 0;
      el.textContent = String(n);
      el.hidden = n < 1;
    });
    paintSize(root);
    // the promise sheet is part of every yn-promise: keep the first one
    var dups = doc.querySelectorAll('[id="yn-sheet-promise"]');
    for (var i = 1; i < dups.length; i++) dups[i].remove();
  }

  // desktop hover: the card's second photo is fetched on first hover and fades in over 260ms
  doc.addEventListener('mouseover', function (e) {
    if (!hoverMq.matches || !e.target.closest) return;
    var m = e.target.closest('.yn-card__media[data-yn-hover-src]');
    if (!m || m.__ynH) return;
    m.__ynH = true;
    var well = m.querySelector('.yn-well'), img = new Image();
    if (!well) return;
    img.alt = ''; img.className = 'yn-card__alt'; img.decoding = 'async';
    img.addEventListener('load', function () { img.classList.add('is-ready'); });
    img.src = m.getAttribute('data-yn-hover-src');
    well.appendChild(img);
  }, { passive: true });

  // view transitions between pages: only the card that was tapped keeps its name (more names = a heavier capture)
  doc.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.yn-card');
    var photo = card && card.querySelector('.yn-card__photo');
    var name = photo ? photo.style.viewTransitionName : '';
    if (name === 'none') name = '';
    win.__ynVtName = name || '';
    try { if (name) win.sessionStorage.setItem('yn-vt', name); else win.sessionStorage.removeItem('yn-vt'); } catch (x) {}
  }, true);
  function keepOnly(name) {
    qa('.yn-card__photo').forEach(function (p) { if (p.style.viewTransitionName && p.style.viewTransitionName !== name) p.style.viewTransitionName = 'none'; });
  }
  win.addEventListener('pageswap', function (e) { if (e.viewTransition) keepOnly(win.__ynVtName || ''); });
  win.addEventListener('pagereveal', function (e) {
    if (!e.viewTransition) return;
    var name = '';
    try { name = win.sessionStorage.getItem('yn-vt') || ''; win.sessionStorage.removeItem('yn-vt'); } catch (x) {}
    keepOnly(name);
  });

  // the theme editor re-renders sections: set the new markup up again, forget sheets that went away
  doc.addEventListener('shopify:section:load', function (e) { hydrate(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) {
    stack.slice().forEach(function (s) { if (e.target.contains(s.el)) { stack.splice(stackIndex(s.el), 1); if (!stack.length) lock(false); } });
  });

  /* ------------------------------------------------------------ start */
  function start() {
    hydrate(doc);
    if ('MutationObserver' in win) {
      var pending = [], queued = false;
      new MutationObserver(function (muts) {
        muts.forEach(function (m) { for (var i = 0; i < m.addedNodes.length; i++) if (m.addedNodes[i].nodeType === 1) pending.push(m.addedNodes[i]); });
        if (!pending.length || queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          pending.splice(0).forEach(function (n) { if (n.isConnected) hydrate(n); });
        });
      }).observe(doc.body, { childList: true, subtree: true });
    }
    Yuno.ready = true;
    emit('yuno:ready', {});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();